import APIService from '.';
import {
  BusinessPayoutByWithdrawDetails,
  BusinessPayoutWithdrawDetails
} from './interfaces/business-payout-withdraw-details.interface';
import {
  BusinessPayoutByWithdraw,
  BusinessPayoutWithdraw
} from './interfaces/business-payout-withdraw.interface';

export default class BusinessPayoutService extends APIService {
  getWithdrawDetails(data: BusinessPayoutByWithdrawDetails) {
    return this.get<BusinessPayoutWithdrawDetails>(
      `/admin/business-payout/withdraw?method=${data.method}`
    );
  }

  withdraw(data: BusinessPayoutByWithdraw) {
    return this.post<BusinessPayoutWithdraw>(
      '/admin/business-payout/withdraw',
      data
    );
  }
}
